<template>
  <div>
    <div v-if="!dataLoaded" class="mt20">
      <van-skeleton title avatar :row="6" />
      <p />
      <van-skeleton title avatar :row="6" />
      <p />
      <van-skeleton title avatar :row="6" />
      <p />
    </div>
    <div v-else>
      <div class="pm70">
        <!-- Navbar -->
        <div class="jhnstop row" v-if="showNavbar">
          <p class="col nav-left pl15">
            <img src="../../assets/img/logo.png" class="loginnhjer cz" />
          </p>
          <div class="nav-right pr15">
            <span class="cf fz15" @click="toHome"> 首页 </span>
          </div>
        </div>
        <!--待付款-->
        <section
          v-if="orderInfo.shouldPay"
          class="order-detail-status pl15 pr15 pt10 pm10"
        >
          <h1 class="fz22">
            <van-icon name="more-o mr10 fz16" />
            <span>{{ orderInfo.orderStatusName }}</span>
          </h1>
          <div v-if="statusInfo" class="order-detail-status-info fz12">
            {{ statusInfo }}
          </div>
        </section>
        <section
          v-if="orderInfo.shouldPay"
          class="order-detail-countdown pl15 pr15 pt10 pm10"
        >
          <div>
            <span class="order-detail-countdown-title">剩余支付时间</span>
            <span class="pl10">{{ countdownText }}</span>
          </div>
          <van-button type="primary" size="small" :square="true" @click="toPay"
            >继续支付</van-button
          >
        </section>
        <!--退款状态-->
        <section v-if="orderInfo.refundStatusName" class="order-detail-refund">
          <div>{{ orderInfo.refundStatusName }}</div>
          <div @click="refundDetail" class="order-detail-refund-action">
            <span>查看详情</span>
            <van-icon name="arrow" />
          </div>
        </section>
        <!--订单信息-->
        <div class="pd mt15">
          <div class="info-box">
            <ul>
              <li v-if="orderInfo.totalMoney > 0">
                <div class="ul-li-label z4 fz13">订单总价</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 zts fz13">
                  ¥ <span class="b">{{ orderInfo.totalMoney.toFixed(2) }}</span>
                </div>
              </li>
              <li>
                <div class="ul-li-label z4 fz13">游客人数</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ orderInfo.totalNum }}
                </div>
              </li>
              <li>
                <div class="ul-li-label z4 fz13">可用数量</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ orderInfo.surplusNum }}
                </div>
              </li>
              <li>
                <div class="ul-li-label z4 fz13">验票时段</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ orderInfo.travelDate }} {{ orderInfo.changCiSTime }}-{{
                    orderInfo.changCiETime
                  }}
                </div>
              </li>
            </ul>
            <ul class="info-box-split pt5 mt5">
              <li>
                <div class="ul-li-label z4 fz13">下单时间</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ orderInfo.cTime }}
                </div>
              </li>
              <li>
                <div class="ul-li-label z4 fz13">订单编号</div>
                <div>:</div>
                <div class="ul-li-vmodel pl5 z4 fz13">
                  {{ orderInfo.listNo }}
                </div>
              </li>
            </ul>
            <div class="info-box-status fz16">
              {{ orderInfo.orderStatusName }}
            </div>
          </div>
        </div>
        <div v-if="orderInfo.tickets.length > 0">
          <!-- 团体或非实名 显示订单号 -->
          <!-- <van-collapse
            v-model="activeWaiBinCollapse"
            class="mt15 sdfsdyywer pd"
            v-if="
              (buyerType == 1 || buyerType == 2) &&
              (orderInfo.keYuanTypeName == '外宾' ||
                orderInfo.waiBinFlag ||
                buyerType == 2)
            "
            accordion
          >
            <van-collapse-item>
              <template #title>
                <div class="dian">
                  <span class="jjnnjxer fz14"> 1 </span>
                  <span class="voucher-tit fz14 z4 ml5">入馆凭证</span>:
                  <span class="ml5 fz14 z4">
                    {{ orderInfo.listNo }}
                  </span>
                </div>
              </template>
              <div class="cen">
                <p>
                  <vueBarcode
                    v-bind:value="orderInfo.listNo"
                    width="1"
                    height="50"
                    displayValue="false"
                  ></vueBarcode>
                  <span style="color: red"
                    >请持相关证件到现场找工作人员核验取票</span
                  >
                </p>
                <p v-if="orderInfo.tickets[0].completed">已用完</p>
                <p v-else-if="orderInfo.tickets[0].used">已用</p>
              </div>
            </van-collapse-item>
          </van-collapse> -->
        </div>
        <!-- 入馆凭证 -->
        <div
          v-if="
            orderInfo.orderStatusName == '待使用' &&
            orderInfo.tickets.length > 0
          "
        >
          <!-- 团体或非实名 显示订单号 -->
          <!-- <van-collapse
            v-model="activeGroupCollapse"
            class="mt15 sdfsdyywer pd"
            v-if="
              (buyerType == 1 || buyerType == 2) &&
              !(
                orderInfo.keYuanTypeName == '外宾' ||
                orderInfo.waiBinFlag ||
                buyerType == 2
              )
            "
            accordion
          >
            <van-collapse-item>
              <template #title>
                <div class="dian">
                  <span class="jjnnjxer fz14"> 1 </span>
                  <span class="voucher-tit fz14 z4 ml5">入馆凭证</span>:
                  <span class="ml5 fz14 z4">
                    {{ orderInfo.listNo }}
                  </span>
                </div>
              </template>
              <div class="cen">
                <div>
                  <img :src="orderInfo.tickets[0].qrcode" class="kjnmjmxeert" />
                  <p v-if="orderInfo.tourists.length > 0">
                    <span style="color: red"
                      >凭预约时二代身份证，可直接检票入馆</span
                    >
                  </p>
                  <p v-else><span style="color: red">凭二维码检票入馆</span></p>
                </div>

                <p v-if="orderInfo.tickets[0].completed">已用完</p>
                <p v-else-if="orderInfo.tickets[0].used">已用</p>
              </div>
            </van-collapse-item>
          </van-collapse> -->
          <van-collapse
            v-model="activeNormalCollapse"
            class="mt15 sdfsdyywer pd"
            accordion
          >
          <!-- <van-collapse
            v-model="activeNormalCollapse"
            class="mt15 sdfsdyywer pd"
            v-if="buyerType != 1 && buyerType != 2"
            accordion
          > -->
            <van-collapse-item
              v-for="(ticket, index) in orderInfo.tickets"
              :key="index"
              :name="index"
            >
              <template #title>
                <div class="dian">
                  <span class="jjnnjxer fz14">
                    {{ index + 1 }}
                  </span>
                  <span class="voucher-tit fz14 z4 ml5">入馆凭证</span>:
                  <span class="ml5 fz14 z4">
                    {{ ticket.ticketCode }}
                  </span>
                </div>
                <div class="voucher-con">
                  <div class="left-row-name z4 fz13 pt5">
                    {{ ticket.ticketTypeName }}
                    <div
                      v-if="ticket.ticketStatusName"
                      :class="{
                        'left-row-status': true,
                        'left-row-invalid': ticket.completed || ticket.used,
                      }"
                    >
                      {{
                        ticket.completed
                          ? "已用完"
                          : ticket.used
                          ? "已用"
                          : "待使用"
                      }}
                    </div>
                  </div>
                  <div
                    class="left-row-tourist fz10"
                  >
                    <div v-if="ticket.name" class="tourist-icon-name">
                      {{ ticket.name }}
                    </div>
                    <div v-if="ticket.certNo" class="row-tourist-icon">
                      <van-icon name="idcard fz14" />
                    </div>
                    <div v-if="ticket.certNo" class="row-tourist-certno">
                      {{ ticket.certNo }}
                    </div>
                    &nbsp;
                  </div>
                </div>
                <div class="content-right-operation">扫码进馆</div>
              </template>
              <div class="cen">
                <img :src="ticket.qrcode" class="kjnmjmxeert" />
                <p>
                  <span style="color: red"
                    >扫描二维码，检票入馆</span
                  >
                </p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div class="oper-box pl5 pr5 pt10 pm10">
        <van-button
          v-if="orderInfo.allowCancel"
          type="primary"
          @click="onCancel"
          class="oper-box-btn pt10 pm10 mr10 cen w80"
          >{{ refundText }}</van-button
        >
        <van-button
          v-if="orderInfo.orderStatusName == '待使用'"
          type="primary"
          class="oper-box-btn pt10 pm10 cen mr10 w80"
          :loading="changeLoading"
          @click="onChange"
          >改签</van-button
        >
      </div>
    </div>

    <van-popup
      v-model="showChangCi.show"
      position="bottom"
      :style="{ position: 'sticky', height: 'calc(100vh)' }"
    >
      <div v-if="!showOrderInfo" class="row navBar1">
        <p class="col nav-left pl15">
          <img src="../../assets/img/logo.png" class="loginnhjer cz" />
        </p>
        <div class="nav-right pr15">
          <span class="cf fz15" @click="showChangCi.show = false">关闭</span>
        </div>
      </div>
      <div class="pd mt60">
        <div class="info-box">
          <ul>
            <li>
              <div class="ul-li-label z4 fz13">参观日期</div>
              <div>:</div>
              <div class="ul-li-vmodel pl5 z4 fz13">
                {{ orderInfo.travelDate }}
              </div>
            </li>
            <li>
              <div class="ul-li-label z4 fz13">验票时段</div>
              <div>:</div>
              <div class="ul-li-vmodel pl5 z4 fz13">
                {{ orderInfo.changCiSTime }}-{{ orderInfo.changCiETime }}
              </div>
            </li>
            <li>
              <div class="ul-li-label z4 fz13">游客人数</div>
              <div>:</div>
              <div class="ul-li-vmodel pl5 z4 fz13">
                {{ orderInfo.totalNum }}
              </div>
            </li>
            <li v-if="orderInfo.totalMoney > 0">
              <div class="ul-li-label z4 fz13">订单总价</div>
              <div>:</div>
              <div class="ul-li-vmodel pl5 zts fz13">
                ¥ <span class="b">{{ orderInfo.totalMoney.toFixed(2) }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="pd mt10 mb10">
        <p class="mt10 fz16">请重新选择验票时段</p>
        <van-grid
          v-if="
            !wxLastBookTime && changCis[0] && changCis[0].children.length > 0
          "
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="changCi in changCis[0].children"
            :key="changCi.value"
            :name="changCi.value"
          >
            <div
              class="fgdrtwerab"
              style="border-radius: 6px"
              :class="[newChangCiId == changCi.value ? 'act' : '']"
              @click="changCiClick(changCi)"
            >
              <p class="fz17 z6">{{ changCi.text }}</p>
              <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
            </div>
          </van-grid-item>
        </van-grid>
        <div v-else class="panel-content">
          <div class="pd" style="color: red; line-height: 50px">
            当前没有参观时段可供改签
          </div>
        </div>
        <div class="pt30 fz13">
          <div style="float: left">
            <van-icon name="warning" color="#a9716d" size="20px" />
          </div>
          <div style="float: left">
            &nbsp;&nbsp;欲选择其他参观日入场，取消订单后另行预约
          </div>
        </div>
      </div>
      <div :disabled="orderInfo.allowCancel" class="dsfsdtywwer cen mt50">
        <van-button
          type="primary"
          @click="changCiChange"
          :loading="changCiChangeLoading"
          class="w100"
          >订单改签</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import vueBarcode from "vue-barcode";
import QRCode from "qrcode";
import orderService from "@/services/orderService.js";
import dateHelper from "@/utils/dateHelper.js";
import scenicService from "./../../services/scenicService.js";

export default {
  name: "order-info",
  props: {
    listNo: {
      type: String,
    },
    showNavbar: {
      type: Boolean,
      default: true,
    },
    showChangCi: {
      type: Object,
      default: function () {
        return { show: false };
      },
    },
    showOrderInfo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vueBarcode,
  },
  data() {
    return {
      loading: false,
      dataLoaded: false,
      activeWaiBinCollapse: 0,
      activeGroupCollapse: 0,
      activeNormalCollapse: 0,
      orderInfo: {
        tickets: [{ ticketTypeName: "" }],
        tourists: [],
        contact: { contactMobile: "" },
      },
      buyerType: "",
      wxLastBookTime: false,
      newChangCiId: "",
      changCis: [],
      loadingExplainer: false,
      changeLoading: false,
      changCiChangeLoading: false,
      countdownText: "",
      timer: -1,
    };
  },
  computed: {
    statusInfo() {
      switch (this.orderInfo.orderStatusName) {
        case "待付款": {
          return "库存有限，请尽快完成付款";
        }
        case "退款中": {
          return "退款申请已提交，我们将尽快为您处理";
        }
        case "已取消": {
          return "您的订单已取消，欢迎重新预订";
        }
        case "已审核": {
          return "预订已成功，祝您出游愉快";
        }
      }
      return "";
    },
    allowCancel() {
      return this.orderInfo.shouldPay || this.orderInfo.totalMoney == 0;
    },
    refundText() {
      return this.allowCancel ? "申请取消" : "申请退款";
    },
    font_size() {
      var windowWidth = document.documentElement.clientWidth;
      var fontSize = (windowWidth - 40) / 20;
      if (fontSize > 32) fontSize = 32;
      return "font-size:" + fontSize + "px";
    },
  },
  methods: {
    async ticketChangCiChanges() {
      let order = await orderService.ticketChangCiChangesAsync(
        this.listNo,
        this.newChangCiId,
        this.orderInfo.tickets[0].ticketTypeId
      );
      this.showChangCi.show = false;
      await this.initOrder(order);
      this.$toast("操作成功");
    },
    async initOrder(order) {
      if (order) {
        if (
          order.tickets &&
          order.tickets.length > 0 &&
          (order.tickets[0].buyerType == "团体" ||
            order.tickets[0].buyerType == "接待")
        ) {
          //团体
          this.buyerType = 1;
        } else if (
          order.tourists &&
          order.tourists.length > 0 &&
          order.tourists.find((t) => {
            return t.certTypeId != 5 && !t.birthday;
          })
        ) {
          //非团体非实名认证
          this.buyerType = 2;
        }
        // if (
        //   (this.buyerType == 1 || this.buyerType == 2) &&
        //   order.tickets &&
        //   order.tickets.length > 0
        // ) {
        //   order.tickets[0].qrcode = await this.generateQRCode(this.listNo);
        // } else 
        if (order.tickets && order.tickets.length > 0) {
          for (let i = 0; i < order.tickets.length; i++) {
            let ticket = order.tickets[i];
            ticket.qrcode = await this.generateQRCode(ticket.ticketCode);
          }
        }
        this.orderInfo = order;
        if (!this.orderInfo.tickets || this.orderInfo.tickets.length == 0) {
          this.orderInfo.tickets = [{ ticketTypeName: "" }];
        }
      }
    },
    async changCiChange() {
      this.changCiChangeLoading = true;
      if (!this.newChangCiId) {
        this.$toast("请选择参观时段！");
        this.changCiChangeLoading = false;
      } else {
        try {
          await this.ticketChangCiChanges();
          this.changCiChangeLoading = false;
        } catch {
          this.$toast("操作失败，请稍候重试！");
          this.changCiChangeLoading = false;
        }
      }
    },
    changCiClick(changCi) {
      this.newChangCiId = changCi.value;
    },
    encryption(val) {
      if (val.length >= 4) {
        return val.substr(0, val.length - 4) + "****";
      } else {
        return val;
      }
    },
    toHome() {
      this.$router.push("/");
    },
    async onAccordionChange(index) {
      if (index === "" || this.orderInfo.tickets[index].qrcode) {
        return;
      }

      let ticket = this.orderInfo.tickets[index];
      ticket.qrcode = await this.generateQRCode(
        this.orderInfo.tickets[index].ticketCode
      );
    },
    async getChangCis(travelDate, groundId) {
      if (!travelDate || !groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.newChangCiId = "";
      //场次
      var changCis = await scenicService.getGroundChangCiItemsAsync({
        travelDate: travelDate,
        groundId: groundId,
      });
      var orderChangCiId = this.orderInfo.changCiId;
      changCis = changCis.filter(function (elem) {
        return elem.changCiId != orderChangCiId;
      });
      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum:
                c.surplusNum > c.changCiNum ? c.changCiNum + "+" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];
    },
    async onChange() {
      this.changeLoading = true;
      await this.getChangCis(
        this.orderInfo.travelDate,
        this.orderInfo.tickets[0].ticketTypeId
      );
      this.showChangCi.show = true;
      this.changeLoading = false;
    },
    async onCancel() {
      if (this.allowCancel) {
        try {
          this.loading = true;
          await this.$dialog.confirm({ title: "确定取消预约？" });
          await this.cancelOrder();
        } catch (err) {
          return;
        } finally {
          this.loading = false;
        }
      } else {
        this.$router.push({
          name: "refundticket",
          params: { listNo: this.listNo },
        });
      }
    },
    async cancelOrder() {
      let response = await orderService.cancelOrderAsync(this.listNo);
      if (response.success) {
        this.$toast("取消成功");
        await this.getOrderInfo();
      }
    },
    async getOrderInfo() {
      try {
        this.loading = true;
        this.dataLoaded = false;
        this.showChangCi.show = false;
        let order = await orderService.getOrderInfoForMobileAsync(this.listNo);
        await this.initOrder(order);
        this.loading = false;
        this.dataLoaded = true;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.dataLoaded = true;
      }
    },
    async generateQRCode(text) {
      if(text){
         try {
          return await QRCode.toDataURL(text, { width: 200 });
        } catch (err) {
            alert(1)
          this.$toast(err);
        }
      }
      else{
        return '';
      }
    },
    startCountdown() {
      clearInterval(this.timer);

      if (!this.orderInfo.shouldPay) {
        return;
      }
   
      const endTime = dayjs("2018-01-01 00:00:00");
      let countdown = endTime.clone().addSeconds(this.orderInfo.expireSeconds);

      const formatStr =
        this.orderInfo.expireSeconds > 3600 ? "HH:mm:ss" : "mm:ss";
      this.countdownText = countdown.format(formatStr);

      this.timer = setInterval(() => {
        countdown = countdown.subtract(1, "seconds");
        this.countdownText = countdown.format(formatStr);
        if (countdown.isSame(endTime)) {
          clearInterval(this.timer);
          this.getOrderInfo();
        }
      }, 1000);
    },
    toPay() {
      let productName = "";
      if (this.orderInfo.tickets && this.orderInfo.tickets.length > 0) {
        this.orderInfo.tickets.forEach((q) => {
          if (`、${productName}`.indexOf(`、${q.ticketTypeName}、`) < 0) {
            productName += `${q.ticketTypeName}、`;
          }
        });
      }
      if (productName) {
        productName = productName.substring(0, productName.lastIndexOf("、"));
      } else {
        productName = "门票";
      }

      this.$router.push({
        name: "wxjspay",
        params: { listNo: this.listNo, payTitle: productName },
      });
    },
    refundDetail() {
      this.$router.push({
        name: "refunddetail",
        params: { listNo: this.listNo },
      });
    },
  },
  watch: {
    listNo: async function () {
      this.buyerType = "";
      await this.getOrderInfo();
    },
  },
  async created() {
    this.buyerType = "";
    await this.getOrderInfo();
    this.startCountdown();
  },
};
</script>

<style lang="scss">
.order-detail-status {
  background-color: #b1605f;
  color: #fff;
  h1 {
    font-weight: 400;
  }

  .order-detail-status-info {
    padding-left: 22px;
  }
}
.order-detail-countdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fefcf3;
  color: #481a03;

  .order-detail-countdown-title {
    font-weight: 400;
  }

  button {
    width: 30%;
    padding: 0;
  }
}

.order-detail-refund {
  border-radius: 5px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  background-color: #fff;
  font-size: 13px;
  margin: 0 0px 10px;

  .order-detail-refund-action {
    span {
      display: inline-block;
      vertical-align: middle;
    }

    i {
      vertical-align: middle;
      margin-top: -2px;
    }
  }
}

.info-box {
  padding: 5px 0px 9px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -2px #c5c0c0;
  overflow: hidden;

  .info-box-split {
    border-top: 1px dotted #dbdbdb;
  }
  ul li {
    display: flex;
    align-items: flex-end;
    padding: 4px 0px 0px 15px;
    .ul-li-label {
      width: 55px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines; // 这行必加，兼容ie浏览bai器
      padding-right: 3px;
    }
    .ul-li-vmodel {
      width: calc(100% - 115px);
    }
  }

  .info-box-status {
    position: absolute;
    right: -5px;
    top: -20px;
    width: 70px;
    height: 70px;
    background: #810102;
    border-radius: 50px;
    text-align: center;
    line-height: 80px;
    color: #fff;
  }
}

.sdfsdyywer .van-collapse-item {
  border-radius: 5px !important;
  box-shadow: 0px 0px 20px -2px #c5c0c0 !important;
  position: relative;

  .van-cell--clickable:active {
    background: #fff;
  }
  .van-cell::after {
    border: none;
  }
  .voucher-tit {
    padding-right: 3px;
  }
  .voucher-con {
    .left-row-name {
      display: flex;
      align-items: center;
      .left-row-status {
        display: flex;
        justify-content: center;
        border-radius: 5px;
        min-width: 46px;
        height: 18px;
        line-height: 18px;
        border: 1px solid #810102;
        color: #810102;
        margin-left: 8px;
      }

      .left-row-invalid {
        border-color: #999;
        color: #999;
      }
    }

    .left-row-tourist {
      display: flex;
      align-items: center;
      .row-tourist-icon {
        padding: 0 3px 0 5px;
        color: #999;
      }
    }
  }

  .content-right-operation {
    position: absolute;
    right: 14px;
    bottom: 12px;
    margin-top: 8px;
    width: 45px;
    height: 45px;
    border-radius: 5px;
    text-align: center;
    display: flex;
    align-items: center;
    padding: 0px 5px;
    background: #810102;
    color: #fff;
    line-height: 18px;
  }
}

.jjnnjxer {
  width: 17px;
  height: 17px;
  background: #810102;
  color: #fff;
  display: inline-block;
  border-radius: 4px;
  text-align: center;
  line-height: 17px;
}

.kjnmjmxeert {
  width: 140px;
  height: 140px;
}
.navBar1 {
  height: 44px;
  line-height: 44px;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 30000;
}
.nav-left,
.nav-right {
  width: 50%;
}
.nav-left {
  background: linear-gradient(to right, #6b1514, #871515);
}
.nav-right {
  text-align: right;
  background: linear-gradient(to right, #871515, #6b1514);
}

.oper-box {
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 1000;
  .oper-box-btn {
    max-width: 30%;
    margin: 0px 10px;
    border-radius: 22px;
  }
}
</style>
